<template>
  <div>
    <!-- modal -->
    <b-modal
      id="modal-prevent-closing-2"
      ref="my-modal"
      title="Adicionar módulo"
      ok-title="Salvar alterações"
      cancel-variant="outline-secondary"
      centered
      size="xs"
      ok-only
      footer-class="justify-content-center"
      @show="resetModal"
      @ok="handleOk"
    >
      <form
        ref="form"
        @submit.stop.prevent="handleSubmit"
      >
        <b-form-group
          :state="nameState"
          label="Nome do módulo"
          label-for="name-input"
          invalid-feedback="Nome do módulo obrigatório"
        >
          <b-form-input
            id="name-input"
            v-model="module.modulo_name"
            :state="nameState"
            required
          />
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ModuloService } from '@/services/Modulo'

export default {
  components: {
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data: () => ({
    nameState: null,
    submittedNames: [],
    module: {
      id: '',
      modulo_name: '',
      modulo_ativo: '',
    },
  }),
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.modulo_name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.updateModuloModal()
      // Push the name to submitted names
      this.submittedNames.push(this.modulo_name)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    modalToggle(module) {
      const { id, modulo_name, modulo_ativo } = module
      this.module = {
        id,
        modulo_name,
        modulo_ativo,
      }
      this.$bvModal.show('modal-prevent-closing-2')
    },
    async updateModuloModal() {
      const moduloService = new ModuloService()
      const refreshEvent = new Event('refresh')
      await moduloService.UpdateModulo(this.module.id, this.module)
        .then(() => {
          window.dispatchEvent(refreshEvent)
        })
        .catch(error => {
          console.log('error', error)
        })
    },
  },
}
</script>
